export const ThisOrThatQuiz = {
  className: "slideLR thisThat",
  type: "Mostly",
  imgPath: "https://s3-us-west-2.amazonaws.com/s.cdpn.io/40041/",
  questions: [
    {
      question: "Would you rather",
      choices: ["get your favorite flavor of ice cream", "try something new"],
    },
    {
      question: "Would you rather have",
      choices: ["a simple taco", "loaded nachos"],
    },
    {
      question: "Would you rather eat",
      choices: [
        "pizza with one topping",
        "go for the slice of day, whatever it is",
      ],
    },
    {
      question: "Would you rather have",
      choices: [
        "a hamburger, hold the veggies",
        "a deluxe cheeseburger with extra pickle",
      ],
    },
    {
      question: "Would you rather get",
      choices: ["French fries", "Onion rings"],
    },
    {
      question: "Would you rather have a chocolate chip cookie",
      choices: ["with nuts", "without"],
    },
    {
      question: "Would you rather have",
      choices: ["orange juice", "a triple berry smoothie"],
    },
    {
      question: "Would you rather eat",
      choices: [
        "a hot dog on a stick with ketchup for dipping",
        "a hot dog on a bun with all the toppings",
      ],
    },
    {
      question: "Would you rather get",
      choices: ["buttered popcorn", "cheese and caramel corn mixed together"],
    },
    {
      question: "Would you rather have",
      choices: ["chocolate candy", "fruit-flavored candy"],
    },
  ],
  results: [
    {
      copy:
        "You and Sarah are similar snackers! Sarah knows what she likes and sticks with it. She doesn’t like to mix too many flavors together, and she hates eating messy food at the mall.",
    },
    {
      copy:
        "You and I eat alike. I like to try new tastes and test out different combinations. Oh, and messy meals in public don’t bother me at all.",
    },
  ],
};
